const namespaced = true;

const state = {
  items: [],
  course: [],
  teacher: []
};

const getters = {
  items: state => state.items,
  teacher: state => state.teacher,
  course: state => state.course
};

const mutations = {
  SET_ITEM: (state, payload) => (state.items = payload),
  SET_TEACHER: (state, payload) => (state.teacher = payload),
  SET_COURSE: (state, payload) => (state.course = payload),
  filterCourse: (state, payload) => {
    return (state.course = state.course.filter(course => course.courseId !== payload));
  },
  backCourse: (state, payload) => {
    return state.course.push({ courseId: payload.courseId, name: payload.name });
  },
  filterTeacher: (state, payload) => {
    return (state.teacher = state.teacher.filter(teacher => teacher.userId !== payload));
  },
  backTeacher: (state, payload) => {
    return state.teacher.push({ userId: payload.teacherId, fullName: payload.fullName });
  }
};

const actions = {
  // async fetchList({ commit, rootGetters }, payload) {
  //   try {
  //     const defaultPageable = rootGetters['table/defaultPageable'];
  //     const sortBy = payload.sortBy?.[0] ? `${payload.sortBy?.[0]}|${payload.sortDesc?.[0] ? 'desc' : 'asc'}` : null;
  //     const params = {
  //       size: defaultPageable.limit,
  //       page: defaultPageable.currentPage - 1,
  //       search: defaultPageable.search,
  //       yearPeriode: payload.yearPeriode,
  //       status: payload.status,
  //       sortBy
  //     };

  //     let url = `/api/class`;
  //     if ((payload.status !== '' && typeof payload.status != 'undefined') || payload.yearPeriode) {
  //       url = url.concat(`/filter`);
  //     }

  //     const {
  //       data: { data }
  //     } = await window.axios.get(url, { params });
  //     const { content, totalPages, totalElements } = data;

  //     commit('SET_ITEM', content);
  //     commit('table/SET_DEFAULT_TOTAL_PAGES', totalPages, { root: true });
  //     commit('table/SET_DEFAULT_TOTAL_ELEMENTS', totalElements, { root: true });
  //   } catch (err) {
  //     throw err;
  //   }
  // },

  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class?search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchFilter({ commit }, { status, search }) {
    console.log(status)
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/filter?status=${status}&search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchStudent({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/grade/${payload}/student-list`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchStudentEdit({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/${payload}/student`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  async fetchTeacher({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/teacher`);

      commit('SET_TEACHER', data);
    } catch (err) {
      throw err;
    }
  },

  async fetchCourse({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/course`);

      commit('SET_COURSE', data);
    } catch (err) {
      throw err;
    }
  },

  async fetchCourseEdit({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/course/update/${payload}`);

      commit('SET_COURSE', data);
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async save({ commit }, payload) {
    var paylod = payload;
    // for (var i = 0; i < paylod.courses.length; i++) {
    //   delete paylod.courses[i]['name'];
    // }
    // console.info(paylod);
    return window.axios.post('/api/class', paylod);
  },

  // eslint-disable-next-line no-unused-vars
  async update({ commit }, paylod) {
    // for (var ii = 0; ii < paylod.courses.length; ii++) {
    //   for (var a = 0; a < paylod.courses[ii].teachers.length; a++) {
    //     if (paylod.courses[ii].teachers[a].status == false) {
    //       if (ii > -1) {
    //         paylod.courses[ii].teachers.splice(ii, 1);
    //       }
    //     }
    //   }
    // }
    // for (var i = 0; i < paylod.students.length; i++) {
    //   if (paylod.students[i].status == false) {
    //     if (i > -1) {
    //       paylod.students.splice(i, 1);
    //     }
    //   }
    // }
    // console.info(paylod);
    return window.axios.put(`/api/class/${paylod.classroomId}`, paylod);
  },

  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/class/${payload.classroomId}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
